import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import { Link } from 'react-router-dom'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Error() {
  return (
    <>
      <SEO 
                title="404 Sayfa Bulunamadı - Haseki Sultan Kız Öğrenci Yurdu"
                description="Aradığınız sayfa bulunamadı."
                url="/error"
            />
      <HeaderOne />
      <Breadcrumb
        title="404 Sayfa Bulunamadı"
      />
      <section className="space bg-smoke">
        <div className="container">
          <div className="row flex-row-reverse align-items-center">
            <div className="col-lg-6">
              <div className="error-img">
                <img src="/assets/img/theme-img/error.svg" alt="404" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="error-content">
                <h1 className="error-title">Üzgünüz! Sayfa Bulunamadı</h1>
                <h2 className="error-subtitle">
                  Aradığınız sayfa mevcut değil veya taşınmış olabilir
                </h2>
                <p className="error-text">
                  Aradığınız sayfa bulunamadı. Lütfen ana sayfaya dönerek tekrar deneyin.
                </p>
                <Link to="/" className="th-btn style3">
                  <img src="/assets/img/icon/right-arrow2.svg" alt="" />
                  Ana Sayfaya Dön
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterFour />
      <ScrollToTop />
    </>
  )
}

export default Error
